// @flow

import {
  SI_GET_ALL_THEMES_REQUEST,
  SI_GET_ALL_THEMES_SUCCESS,
  SI_GET_ALL_THEMES_FAILURE,
  SI_UPDATE_ALL_THEMES,
  SIThemeState,
  SIThemeAction,
  SI_GET_THEME_DETAIL_REQUEST,
  SI_GET_THEME_DETAIL_SUCCESS,
  SI_GET_THEME_DETAIL_FAILURE,
  SI_GET_ALL_THEMES_SHOPIFY_REQUEST,
  SI_GET_ALL_THEMES_SHOPIFY_SUCCESS,
  SI_GET_ALL_THEMES_SHOPIFY_FAILURE,
  SI_RESET_CACHE_THEMES
} from 'stores/flow-type/shopify-integration/theme.type';

const initialState: SIThemeState = {
  getAllThemesLoading: false,
  allThemes: [],
  cacheThemes: [],
  total: 0,
  themeDetail: {},
  themeDetailLoading: false,
  themeDetailSuccess: false,
  themeDetailError: undefined,

  allThemesShopify: [],
  getAllThemesShopifyLoading: false
};

const shopifyIntegrationThemeReducers = (
  state: SIThemeState = initialState,
  action: SIThemeAction
) => {
  switch (action.type) {
    case SI_RESET_CACHE_THEMES: {
      return {
        ...state,
        cacheThemes: []
      };
    }

    case SI_GET_ALL_THEMES_REQUEST:
      return { ...state, getAllThemesLoading: true, getAllThemesSuccess: false };
    case SI_GET_ALL_THEMES_SUCCESS: {
      // Data from API has been already sorted by updated_at
      const { data, page } = action.payload || {};
      const { themes = [], total = 0 } = data || {};
      // Move live theme to the top
      // const allThemesCloned = [...data];
      // allThemesCloned.sort((a, b) => (moment(a.updated_at).isAfter(moment(b.updated_at)) ? -1 : 1));

      // // Move live theme on top of list
      // const liveThemeIndex = allThemesCloned.findIndex(theme => theme.role === 'main');
      // if (liveThemeIndex !== -1) {
      //   const liveTheme = { ...allThemesCloned[liveThemeIndex] };
      //   allThemesCloned.splice(liveThemeIndex, 1);
      //   allThemesCloned.unshift(liveTheme);
      // }
      const newCachedTheme = { ...state.cacheThemes };
      newCachedTheme[page] = themes;

      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: true,
        error: undefined,
        allThemes: themes,
        cacheThemes: newCachedTheme,
        total
      };
    }
    case SI_GET_ALL_THEMES_FAILURE:
      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: false,
        error: action.payload
      };

    case SI_GET_ALL_THEMES_SHOPIFY_REQUEST:
      return { ...state, getAllThemesShopifyLoading: true };
    case SI_GET_ALL_THEMES_SHOPIFY_SUCCESS: {
      // Data from API has been already sorted by updated_at
      const { data } = action.payload || {};

      return {
        ...state,
        getAllThemesShopifyLoading: false,
        allThemesShopify: data
      };
    }
    case SI_GET_ALL_THEMES_SHOPIFY_FAILURE:
      return {
        ...state,
        getAllThemesShopifyLoading: false
      };

    case SI_UPDATE_ALL_THEMES: {
      const { data } = action.payload;
      return {
        ...state,
        allThemes: data
      };
    }

    case SI_GET_THEME_DETAIL_REQUEST:
      return {
        ...state,
        themeDetailLoading: true,
        themeDetailSuccess: false,
        themeDetailError: undefined
      };
    case SI_GET_THEME_DETAIL_SUCCESS: {
      const { data } = action.payload || {};
      return {
        ...state,
        themeDetail: data,
        themeDetailLoading: false,
        themeDetailSuccess: true,
        themeDetailError: undefined
      };
    }
    case SI_GET_THEME_DETAIL_FAILURE:
      return {
        ...state,
        themeDetailLoading: false,
        themeDetailSuccess: false,
        themeDetailError: action.payload
      };

    default:
      return state;
  }
};
export default shopifyIntegrationThemeReducers;
